import { render, staticRenderFns } from "./ChartBar.vue?vue&type=template&id=51355ea8&scoped=true"
import script from "./ChartBar.vue?vue&type=script&lang=js"
export * from "./ChartBar.vue?vue&type=script&lang=js"
import style0 from "./ChartBar.vue?vue&type=style&index=0&id=51355ea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51355ea8",
  null
  
)

export default component.exports